module.exports = __webpack_public_path__ + "img/61.10.pH.84546e91.png";